export const LOAD_MORE_BUTTON_ID = 'load-more-button';
export const NO_RESULTS = 'no-results';
export const RESULTS_CARD = 'results-card';
export const RESULTS_LOADING_CARD = 'results-loading-card';
export const RESULTS_DROPDOWN_SORT = 'results-dropdown-sort';
export const RESULTS_DROPDOWN_ROOM = 'results-dropdown-room';
export const FAKE_RESULTS_COUNT = 4;
export const SCROLLING_OFFSET = 36;
export const PAGE_HEADER_ID = 'aemHeaderContainer';
export const BANNER_PLACEHOLDER_ID = 'banner-placeholder';
